<div class="p-5 sm:p-10 h-full w-full flex flex-col">
  <div class="rounded-3xl bg-gradient-to-r from-k-green to-k-yellow flex justify-center max-w-[1200px]">
    <div
      class="green-rectangle m-[1px] w-full flex rounded-3xl relative p-7 lg:pl-[220px] pl-7 pr-7 sm:pr-[220px] bg-k-darker place-content-center md:place-content-start">
      <!-- <div class="pic-container relative w-[150px] h-[150px]"> -->
      <img class="absolute left-0 top-[-15px] w-[228px] h-[182px] hidden lg:block"
        src="./assets/img/Home/WoK-Cellphone 2.png" />
      <!-- </div> -->
      <div class="buttons-container flex flex-col gap-4">
        <div class="desktop-container flex gap-2 items-center justify-center sm:justify-start">
          <img class="sm:block hidden w-[27px] h-[24px]" [ngClass]="{'opacity-20':isDisabled}"
            src="./assets/img/Icon/Icon-Desktop.svg" />
          <h1 class="sm:block hidden text-lg font-space " [ngClass]="{'opacity-20':isDisabled}">DESKTOP:</h1>
          <a class="windows-download download relative"
            [ngClass]="{'cursor-default pointer-events-none opacity-20':isDisabled}" [href]="windowsAppUrl"
            target="_blank">
            <img class="h-[40px] min-w-[112.59px]" src="./assets/img/Home/play-windows.svg" />
            <!-- ALPHA -->
            <!-- <img class="h-[25px] absolute top-[-9px] right-2" src="./assets/img/Home/alpha.svg" /> -->
          </a>
          <div class="hidden sm:block rounded-lg px-6 py-1 border-k-cards-border border-[3px]">
            <span class="font-space text-lg font-bold">PLAYABLE 9TH MAY - 3PM UTC</span>
          </div>
        </div>
        <div class="mobile-container flex gap-2 items-center justify-center sm:justify-start">
          <img class="sm:block hidden w-[18px] h-[27px] " [ngClass]="{'opacity-20':isDisabled}"
            src="./assets/img/Icon/App.png" />
          <h1 class="sm:block hidden text-lg font-space " [ngClass]="{'opacity-20':isDisabled}">MOBILE:</h1>
          <a class="android-download download" [ngClass]="{'cursor-default pointer-events-none opacity-20':isDisabled}"
            [href]="androidAppUrl" target="_blank">
            <img class="h-[40px]  min-w-[105.18px]" src="./assets/img/Home/Button-Android.svg" />
          </a>
          <a class="android-download download" [ngClass]="{'cursor-default pointer-events-none opacity-20':isDisabled}"
            [href]="appleAppUrl" target="_blank">
            <img class="h-[40px]  min-w-[77.78px]" src="./assets/img/Home/Button-iOS.svg" />
          </a>
          <span class="text-sm hidden md:block " [ngClass]="{'opacity-20':isDisabled}">iOS users will get the game
            through Test Flight</span>
        </div>
        <span class="text-sm md:hidden block " [ngClass]="{'opacity-20':isDisabled}">iOS users will get the game through
          Test Flight</span>
        <div class="block sm:hidden mx-auto mb-8">
          <k-button buttonStyle="gradient" (click)="whitelist()" [label]="'Whitelist'"></k-button>
        </div>
      </div>
      <!-- <div class="pic-container w-[231px] h-[199px] relative  hidden sm:block ml-auto"> -->
      <!-- DESKTOP -->
      <img class="absolute right-0 w-[231px] h-auto hidden sm:block top-[-23px]"
        src="./assets/img/Home/Kogaea-Dungeons.png" />
      <k-button class="absolute hidden sm:block right-[55px] bottom-[13px]" buttonStyle="gradient" (click)="whitelist()"
        [label]="'Whitelist'"></k-button>
      <!-- </div> -->
      <div class="block absolute sm:hidden bg-gray-dark rounded-lg px-2 border-k-cards-border border-[3px] top-[-14px]">
        <span class="font-space text-lg font-bold">PLAYABLE 9TH MAY - 3PM UTC</span>
      </div>
    </div>
  </div>
  <!-- MOBILE -->
  <div class="flex place-content-center">
    <div class="nobackground w-[231px] relative">
      <img class="absolute w-[231px] h-auto sm:hidden block top-[-40px]" src="./assets/img/Home/Kogaea-Dungeons.png" />
    </div>
  </div>
  <div class="flex mt-10 sm:mt-0 relative pb-20">
    <img src="./assets/img/Home/Pashek 2.png" class="w-128 h-auto mx-auto">
    <div
      class="welcome-text gradient-text-silver absolute uppercase text-4xl sm:text-6xl text-center bottom-18 sm:bottom-0 w-full font-bold font-yanone place-content-center">
      <span>
        welcome to world of kogaea
      </span>
    </div>
  </div>
</div>